import type { FC } from 'react';

import { SWReactIcons } from '@similarweb/icons';

import { Tooltip } from '../../../../../components/Tooltip';
import type { ContactVariant, PrivateDataType } from '../../../../../domain/contact';
import { translate } from '../../../../../services/i18n';

import { PrivateDataBaseItemView } from './PrivateDataBaseItemView';
import { StyledPrivateDataErrorIcon } from './styles';

type Props = {
  type: PrivateDataType;
  animatedMount?: boolean;
  variant?: ContactVariant;
};

export const PrivateDataErrorItemView: FC<Props> = ({ type, variant, animatedMount }) => {
  const tooltip = (
    <Tooltip content={translate('contact_card.unavailable_tooltip')} placement="left" minWidth={150}>
      <StyledPrivateDataErrorIcon>
        <SWReactIcons size="xs" iconName="warning" />
      </StyledPrivateDataErrorIcon>
    </Tooltip>
  );

  return (
    <PrivateDataBaseItemView
      variant={variant}
      isUnavailable
      content={translate('contact_card.unavailable')}
      tooltip={tooltip}
      type={type}
      animatedMount={animatedMount}
    />
  );
};
